import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  IChatMessage,
  IChatThread,
  IChatUser,
  MessageTypeEnum,
} from 'app/@chat/domain';
import { ChatMessageService } from 'app/@chat/services/chat-message.service';
import { ChatUserService } from 'app/@chat/services/chat-user.service';
import { ChatThreadService } from './../../services/chat-thread.service';
import {
  Subject,
  combineLatest,
  BehaviorSubject,
  of,
  Subscription,
} from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ChatService } from 'app/@chat/chat.service';
import { NgZone, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { HttpService } from 'app/@core/backend/common/api/http.service';
import { getMatIconFailedToSanitizeLiteralError } from '@angular/material/icon';
import { NbChatComponent, NbChatMessageFile } from '@nebular/theme';
import { Utility } from 'app/@core/utils/utility';
import { KeyboardDetectionService } from './../../../@core/backend/common/services/keyboard-detection.service';

export type ChatMessageFileType = NbChatMessageFile & {
  fileName: string;
};
export type ChatMessageType = IChatMessage & {
  files: ChatMessageFileType[];
  message: string;
  isFileInfo?: boolean;
  messageType: MessageTypeEnum;
};

@Component({
  selector: 'app-chat-window',
  templateUrl: './chat-window.component.html',
  styleUrls: ['./chat-window.component.scss'],
  //  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatWindowComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('chatBody') private chatBody: ElementRef;
  messages: ChatMessageType[] = [];
  unSeenMessagesCount = 0;
  showAudio: boolean;
  showInput: boolean;
  isKeyboardOpen: BehaviorSubject<boolean> = new BehaviorSubject(false);

  // @Input('isActive')
  // isActive: boolean = false;

  @Input('threadSubject')
  threadSubject: BehaviorSubject<IChatThread>;

  @ViewChild('chat')
  chatWindow: NbChatComponent;

  private $subscription: Subscription = null;

  get thread() {
    return this.threadSubject.value;
  }

  user: IChatUser;

  fetching = false;
  firstTimeLoading = true;

  constructor(
    //  private zone: NgZone,
    private messageService: ChatMessageService,
    private userService: ChatUserService,
    private chatService: ChatService,
    //  private changeDetectorRef: ChangeDetectorRef,
    private httpService: HttpService,
    private keyboardDetectionService: KeyboardDetectionService,
  ) {}

  ngOnInit() {
    this.showAudio = true;
    this.showInput = true;
    this.isKeyboardOpen = this.keyboardDetectionService.keyBoardOpen;
    this.firstTimeLoading = true;
    const messagesForThread = combineLatest([
      this.messageService.messages,
      this.threadSubject,
    ]).pipe(
      map(([messages, thread]) => {
        let _messages: ChatMessageType[] = thread
          ? messages
              .map<ChatMessageType>((msg: ChatMessageType) => {
                msg.files = this.getFilesFromMessage(msg);
                msg.message = this.getTextFromMessage(msg);
                msg.messageType = msg.payloads[0]?.messageType? msg.payloads[0]?.messageType: MessageTypeEnum.Mannual;
                return msg;
              })
              .filter(
                (msg) =>
                  msg && msg.payloads?.length > 0 && msg.threadId === thread.id
              )
          : [];
        _messages = _messages
          .concat(
            _messages
              .filter((msg) => msg.files.length > 0)
              .map((msg) => {
                return this.generateFakeMessageForFiles(msg);
              })
          )
          .sort((a, b) => {
            if (a.dateTime == b.dateTime) return 0;
            return a.dateTime > b.dateTime ? 1 : -1;
          })
          .filter((msg, i, messages) => {
            return !(i > 0 && msg.id == messages[i - 1].id);
          });
        return _messages;
      })
    );

    this.$subscription = messagesForThread.subscribe({
      next: (messages) => {
        // console.log('messages', messages);
        this.unSeenMessagesCount = messages.filter(
          (msg) => !msg.seen && !msg.reply
        ).length;
        this.messages = messages;

        if (this.unSeenMessagesCount > 0) this.chatService.markThreadAsRead(this.thread);
        const scrollableElem = (document.getElementsByClassName('messages')[0]);
        const scrollTop = scrollableElem.scrollTop;
        const scrollBottom = scrollableElem.scrollHeight - scrollTop;
        // check scroll position is top
        if (scrollTop !== 0) {
          setTimeout(() => {
            console.log("Scrolling here");
            scrollableElem.scrollTo(0, scrollableElem.scrollHeight);
          }, 1000);
        }

      },
    });

    this.userService.onUserChange.subscribe({
      next: (user) => {
        this.user = user;
        //console.log('user', user);
      },
    });

    this.threadSubject.subscribe({
      next: (thread) => {
        //........if (this.messages.length <= 0) this.chatService.fetchMessages(thread);
        // this.chatService.markThreadAsRead(this.thread);
      },
    });
  }

  ngAfterViewInit(): void {
    // const scrollableElem = this.chatWindow.scrollable
    //   .nativeElement as HTMLDivElement;
      const scrollableElem = (document.getElementsByClassName('messages')[0]);
      document.getElementsByClassName('input-full-width')[0].addEventListener('focus', () => {
        this.showAudio = false;
      });
      document.getElementsByClassName('input-full-width')[0].addEventListener('blur', () => {
        this.showAudio = true;
      });

    const handleScroll = () => {
      var target = scrollableElem;
      const scrollTop = target.scrollTop;

      if (scrollTop == 0) {
        setTimeout(() => (this.fetching = true));
        this.chatService
          .fetchMessages(this.thread, this.messages[0]?.dateTime)
          .subscribe({
            next: () => {
              //this.chatWindow.scrollListBottom();
              // setTimeout(() => {
              //   try {
              //     this.chatBody.nativeElement.scrollTop = this.chatBody.nativeElement.scrollHeight;
              // } catch(err) {
              //   console.log(err)
              //  }
              // }, 1000);
              setTimeout(() => {
                if(!this.messages || this.messages.length <=10 || this.firstTimeLoading) {
                   target.scrollTo(0, target.scrollHeight);
                   this.firstTimeLoading = false;
                }
                this.fetching = false;
              }, 1000);
            },
            error: (err) => {
              this.fetching = false;
              console.log(err);
            },
          });
      }
    };

    scrollableElem.addEventListener('scroll', handleScroll);
    // scrollableElem.addEventListener('click', () => {
    //   if (this.unSeenMessagesCount > 0)
    //     this.chatService.markThreadAsRead(this.thread);
    // });

    handleScroll();
  }

  sendMessage(e) {
    if (this.unSeenMessagesCount > 0)
      this.chatService.markThreadAsRead(this.thread);

    // console.log(this.thread);
    // console.log(e.files);
    const formData = new FormData();
    for (let i = 0; i < e.files.length; i++) {
      formData.append('files', e.files[i], e.files[i].name);
    }
    const fileNames =
      e.files.length > 0
        ? this.httpService.post('messages/upload', formData)
        : of([]);
    fileNames.subscribe({
      next: (fileNames: string[]) => {
        const payloads = fileNames.map((fN, index) => ({
          data: JSON.stringify(fN),
          messageType: MessageTypeEnum.File,
        }));
        if (e.message) {
          payloads.push({
            data: e.message,
            messageType: MessageTypeEnum.Mannual,
          });
        }
        this.chatService.addMessage({
          dateTime: new Date().toISOString(),
          senderId: this.user.id,
          //  sender: this.user,
          threadId: this.thread?.id,
          payloads,
          reply: true,
        });
      },
    });
  }
public onRecordingSend(audioFile: File): void {
  this.showInput = true;
  if (this.unSeenMessagesCount > 0)
      this.chatService.markThreadAsRead(this.thread);

    // console.log(this.thread);
    // console.log(e.files);
    const formData = new FormData();
      formData.append('files', audioFile,audioFile.name);
    const fileNames = this.httpService.post('messages/upload', formData);
    fileNames.subscribe({
      next: (fileNames: string[]) => {
        const payloads = fileNames.map((fN, index) => ({
          data: JSON.stringify(fN),
          messageType: MessageTypeEnum.File,
        }));
        this.chatService.addMessage({
          dateTime: new Date().toISOString(),
          senderId: this.user.id,
          //  sender: this.user,
          threadId: this.thread?.id,
          payloads,
          reply: true,
        });
      },
    });
}
  private getFilesFromMessage(msg: IChatMessage) {
    const files = msg.payloads
      .filter((p) => p.messageType == MessageTypeEnum.File)
      .map<ChatMessageFileType>((p) => {
        let url = '';
        let fileName = '';
        try {
          url = JSON.parse(p.data)['url'] || '';
          fileName = JSON.parse(p.data)['name'] || '';
        } catch (e) {
          url = p.data;
          fileName = p.data;
        }
        return {
          url: url,
          type: Utility.getFileTypeFromURL(p.data),
          icon: 'file-text-outline',
          fileName,
        };
      });
    return files;
  }
  private getTextFromMessage(msg: IChatMessage) {
    const text = msg.payloads
      .filter((p) =>
      {
        return p.messageType == MessageTypeEnum.Mannual || p.messageType == MessageTypeEnum.Assessment
      })
      .map((p) => p.data)
      .join('\n');
    return text;
  }

  private generateFakeMessageForFiles(msg: ChatMessageType): ChatMessageType {
    if (msg.files.length <= 0) return null;
    const fileNames = msg.files.map((file) => {
      return file.fileName.split('/').reverse()[0] || '';
    });
    let message = `${fileNames[0]}`;
    if (msg.files.length > 1) {
      message = `${fileNames.length} files ${fileNames.join(', ')}`;
    }
    // message += ' been shared with you.';
    return {
      ...msg,
      files: [],
      message,
      isFileInfo: true,
    };
  }

  public trackById(index: number, message: ChatMessageType) {
    return `${message.dateTime}_${message.isFileInfo ? 1 : 0}`;
  }

  public startRecording() {
    this.showInput = false;
  }

  public stopRecording() {
    this.showInput=true;
  }

  ngOnDestroy(): void {
    this.$subscription?.unsubscribe();
  }

  public parseISODate(date: string) {
    return new Date(date.slice(0, 19) + 'Z');
  }
}
